module.exports = __webpack_public_path__ + "sunsemweb/img/ban.0ee6fe8a.png";